export default "__VITE_ASSET__BgL6Lz59__"